import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { GetReportsByCmntIdDTO, GetReportsByPostIdDTO, GetReportsByUserIdDTO, ReportDTO } from './dto/report.dto';
import { AllReportsResponseModel, ReportsResponseModel } from './dto/reports-response-module';
import { ReportEntity } from './report.entity';

@Injectable()
export class ReportService {

    constructor(
        @InjectRepository(ReportEntity)
        private reportRepository: Repository<ReportEntity>,
       
    ) {}

    async createReport(queryParams, reportDto:ReportDTO, request: Request): Promise<ReportsResponseModel> {
        const response = new ReportsResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const saveReport = await this.reportRepository.save(reportDto);
                if(saveReport) {
                    response.status = true;
                    response.data   = saveReport;
                    response.statusCode = 50000;
                    response.internalMessage = 'Report posted successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Report not posted')
                }
            } else {
                const saveReport = await this.reportRepository.save(reportDto);
                if(saveReport) {
                    response.status = true;
                    response.data   = saveReport;
                    response.statusCode = 50000;
                    response.internalMessage = 'Report posted successfully';
                    response.intlCode = 11100;
                } else { 
                    throw new ErrorResponse(11106, 'Report not posted')
                }
            }            
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getReportsByPostId(queryParams, getReportsByPostIdDto:GetReportsByPostIdDTO, request: Request): Promise<AllReportsResponseModel> {
        const response = new AllReportsResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const activeTypes = await this.reportRepository.find({
                    relations:['post','user','user.profile'],
                    where: {postId:getReportsByPostIdDto.postId,  status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const activeTypes = await this.reportRepository.find({
                    relations:['post','user','user.profile'],
                    where: {postId:getReportsByPostIdDto.postId,  status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getReportsByCommentId(queryParams, getReportsByCmntIdDto:GetReportsByCmntIdDTO, request: Request): Promise<AllReportsResponseModel> {
        const response = new AllReportsResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const activeTypes = await this.reportRepository.find({
                    relations:['comments','user','user.profile'],
                    where: {commentId:getReportsByCmntIdDto.commentId,  status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const activeTypes = await this.reportRepository.find({
                    relations:['comments','user','user.profile'],
                    where: {commentId:getReportsByCmntIdDto.commentId,  status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }

    async getReportsByUserId(queryParams, getReportsByUserIdDTO:GetReportsByUserIdDTO, request: Request): Promise<AllReportsResponseModel> {
        const response = new AllReportsResponseModel();
        try {
            if(queryParams.apiVersion == 1) {
                const activeTypes = await this.reportRepository.find({
                    relations:['post','comments','user','user.profile'],
                    where: {userId:getReportsByUserIdDTO.userId,  status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            } else {
                const activeTypes = await this.reportRepository.find({
                    relations:['post','comments','user','user.profile'],
                    where: {userId:getReportsByUserIdDTO.userId,  status: true},
                    order: { createdAt: 'DESC' }
                });
                if(activeTypes) {
                    response.status = true;
                    response.data = activeTypes;
                    response.statusCode = 50000;
                    response.internalMessage = 'Data retrieved successfully';
                    response.intlCode = 11108;
                } else {
                    throw new ErrorResponse(99998, 'Data not found');
                }
            }
            return response;
        } catch (error) {
            throw error;
        }
    }
}
